import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Navigate } from 'react-router';
import { bindActionCreators } from 'redux';
import { Field, Formik, Form } from 'formik';
import * as Yup from 'yup';
import { PATH_CLIENT_EDIT, PATH_CLIENT_MEASUREMENTS, PATH_CLIENT_FACILITY_ADD, PATH_CLIENT_DOSEMETER_ADD, PATH_CLIENT_MEASUREMENT_REPORTS } from 'routing/path'
import PageHeader from 'components/page-header'
import ConfirmActionModal from 'components/modals/confirm-action-modal'
import LinkGroup from 'components/controls/link-group';
import ValidatedField from 'components/controls/validated-field';
import ValidatedDateField from 'components/controls/validated-date-field';
import ValidatedMaskedField from 'components/controls/validated-masked-field';
import ValidatedSelectField from 'components/controls/validated-select-field';
import fetchClientAction from 'actions/client/action.client-get';
import fetchNewClientAction from 'actions/client/action.client-get-new';
import addClientAction from 'actions/client/action.client-add';
import saveClientAction from 'actions/client/action.client-save';
import fetchClientListAction from 'actions/client/action.client-list';
import { getClient, getClientPending, getClientError } from 'store/client/reducer.client-get';
import { getNewClient, getNewClientPending, getNewClientError } from 'store/client/reducer.client-get-new';
import { addClientPending, addClientId } from 'store/client/reducer.client-add';
import { saveClientPending } from 'store/client/reducer.client-save';
import { getClientList, getClientListPending, getClientListError } from 'store/client/reducer.client-list';
import { getTranslations } from 'store/admin-translation/reducer.translations';
import getClientStatusDescription, { CLIENT_STATUS_ACTIVE, CLIENT_STATUS_INACTIVE } from 'data/enums/client-status-enum';
import { DOSEMETER_TYPE_ENVIRONMENTAL, DOSEMETER_TYPE_PERSONAL, DOSEMETER_TYPE_PERSONAL_WRIST } from 'data/enums/dosemeter-type-enum';

class ClientEdit extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fetchClientActionInvoked: false,
			fetchNewClientActionInvoked: false,
			addClientActionInvoked: false,
			lastVatin: null
		};

		this.onChangeVatin = this.onChangeVatin.bind(this);
	}
	
	componentDidMount() {
		this.fetchData();
	}
	
	componentDidUpdate(prevProps) {
		if (this.props.params.id !== prevProps.params.id) {
			this.fetchData();
		}
	}

	fetchData() {
		const clientId = this.props.params.id;
		const { fetchClientAction, fetchNewClientAction } = this.props;

		if (clientId) {
			this.setState({ fetchClientActionInvoked: true });
			fetchClientAction(clientId);
		}
		else {
			this.setState({ fetchNewClientActionInvoked: true });
			fetchNewClientAction();
		}
	}

	onChangeVatin(e, field, values, setValues) {
		const { fetchClientListAction } = this.props;
		const { lastVatin } = this.state;
		const vatin = e.target.value;

		if (vatin && vatin.length === 10 && !vatin.includes("_") && vatin !== lastVatin) {
			const filter = {
				page: 1,
				pageSize: 20,
				vatin: vatin
			};
			fetchClientListAction(filter, false);
			this.setState({ lastVatin: vatin });
		}

		// call formik onChange method
		field.onChange(e);
	}

	handleSubmit(fields) {
		const clientId = this.props.params.id;
		const { addClientAction, saveClientAction } = this.props;

		const client = {
			clientId: clientId ? parseInt(clientId, 10) : fields.clientId,
			name: fields.name,
			vatin: fields.vatin,
			status: parseInt(fields.status),
			since: fields.since,
			remarks: fields.remarks,
			backgroundRadiation: fields.backgroundRadiation ? parseFloat(fields.backgroundRadiation.replace(',', '.')) : null,
			address: {
				city: fields.mainAddressCity,
				postalCode: fields.mainAddressPostalCode,
				street: fields.mainAddressStreet
			},
			invoiceAddress: {
				city: fields.invoiceAddressCity,
				postalCode: fields.invoiceAddressPostalCode,
				street: fields.invoiceAddressStreet
			},
			dosimetryReportAddress: {
				city: fields.dosimetryReportAddressCity,
				postalCode: fields.dosimetryReportAddressPostalCode,
				street: fields.dosimetryReportAddressStreet
			},
			contactPerson: {
				firstName: fields.contactPersonFirstName,
				lastName: fields.contactPersonLastName,
				email: fields.contactPersonEmail,
				phone: fields.contactPersonPhone
			}
		};

		if (clientId) {
			saveClientAction(client);
		}
		else {
			addClientAction(client);
			this.setState({ addClientActionInvoked: true });
		}
	}

	redirect() {
		const { addClientActionInvoked } = this.state;
		const { addClientId } = this.props;
		const clientId = this.props.params.id;

		if (!clientId && addClientId && addClientActionInvoked) {
			return (
				<Navigate to={PATH_CLIENT_EDIT + addClientId} />
			);
		}
	}

	getPageHeader() {
		const { translations } = this.props;
		const clientId = this.props.params.id;
		if (!clientId) {
			// new client
			return <PageHeader title={translations.newClient} breadcrumbs={[]} breadcrumbsCurrentPage={translations.newClient} />
		}

		// existing client
		const { fetchClientActionInvoked } = this.state;
		const { client, clientPending } = this.props;

		if (!fetchClientActionInvoked || clientPending) {
			return <PageHeader title="..." />
		}

		const buttons = [
			<LinkGroup key="goToLinkGroup" buttonId="goToLinkGroup" buttonClassName="btn btn-secondary me-2" label={translations.goTo} buttons={[
				{ id: "clientMeasurementsButton", to: PATH_CLIENT_MEASUREMENTS + clientId, label: translations.measurementList },
				{ id: "clientMeasurementReportsButton", to: PATH_CLIENT_MEASUREMENT_REPORTS + clientId, label: translations.measurementReportList },
			]} />,
			<LinkGroup key="actionAddLinkGroup" buttonId="actionAddLinkGroup" buttonClassName="btn btn-primary me-2" alignEnd={true} label={translations.actionAdd} buttons={[
				{ id: "addEnvironmentalDosemeterButton", to: PATH_CLIENT_DOSEMETER_ADD + clientId + "/" + DOSEMETER_TYPE_ENVIRONMENTAL.toString(), label: translations.dosemeterEnvironmental },
				{ id: "addPersonalDosemeterButton", to: PATH_CLIENT_DOSEMETER_ADD + clientId + "/" + DOSEMETER_TYPE_PERSONAL.toString(), label: translations.dosemeterPersonal },
				{ id: "addPersonalWristDosemeterButton", to: PATH_CLIENT_DOSEMETER_ADD + clientId + "/" + DOSEMETER_TYPE_PERSONAL_WRIST.toString(), label: translations.dosemeterPersonalWrist },
				{ id: "addClientFacility", to: PATH_CLIENT_FACILITY_ADD + clientId, label: translations.clientFacility },
			]} />
		];

		return <PageHeader title={client.name} buttons={buttons} breadcrumbs={[]} breadcrumbsCurrentPage={`${translations.client} ${client.name}`} />
	}

	getFormValues() {
		const clientId = this.props.params.id;
		const { fetchClientActionInvoked, fetchNewClientActionInvoked } = this.state;
		const { client, clientPending, newClient, newClientPending } = this.props;

		const initializeClient = clientId && fetchClientActionInvoked && !clientPending;
		const initializeNewClient = !clientId && fetchNewClientActionInvoked && !newClientPending;
		return {
			clientId: initializeClient ? client.clientId.toString().padStart(4, '0') : initializeNewClient ? newClient.clientId.toString().padStart(4, '0') : "",
			name: initializeClient ? client.name : "",
			vatin: initializeClient ? client.vatin : "",
			status: initializeClient ? client.status : CLIENT_STATUS_ACTIVE,
			since: initializeClient ? client.since : "",
			remarks: initializeClient ? client.remarks : "",
			backgroundRadiation: initializeClient ? client.backgroundRadiation?.toString().replace('.', ',') : "",
			mainAddressCity: initializeClient ? (client.address?.city ?? "") : "",
			mainAddressPostalCode: initializeClient ? (client.address?.postalCode ?? "") : "",
			mainAddressStreet: initializeClient ? (client.address?.street ?? "") : "",
			invoiceAddressCity: initializeClient ? (client.invoiceAddress?.city ?? "") : "",
			invoiceAddressPostalCode: initializeClient ? (client.invoiceAddress?.postalCode ?? "") : "",
			invoiceAddressStreet: initializeClient ? (client.invoiceAddress?.street ?? "") : "",
			dosimetryReportAddressCity: initializeClient ? (client.dosimetryReportAddress?.city ?? "") : "",
			dosimetryReportAddressPostalCode: initializeClient ? (client.dosimetryReportAddress?.postalCode ?? "") : "",
			dosimetryReportAddressStreet: initializeClient ? (client.dosimetryReportAddress?.street ?? "") : "",
			contactPersonFirstName: initializeClient ? (client.contactPerson?.firstName ?? "") : "",
			contactPersonLastName: initializeClient ? (client.contactPerson?.lastName ?? "") : "",
			contactPersonEmail: initializeClient ? (client.contactPerson?.email ?? "") : "",
			contactPersonPhone: initializeClient ? (client.contactPerson?.phone ?? "") : ""
		};
	}

	render() {
		const redirect = this.redirect();
		if (redirect) {
			return redirect;
		}

		const pageHeader = this.getPageHeader();
		const initialValues = this.getFormValues();

		const { saveClientPending, clientListPending, clientList, translations } = this.props;
		const { lastVatin } = this.state;
		const clientId = this.props.params.id;
		const clientStatusesToDropDownList = [
			[CLIENT_STATUS_ACTIVE, getClientStatusDescription(CLIENT_STATUS_ACTIVE, translations)],
			[CLIENT_STATUS_INACTIVE, getClientStatusDescription(CLIENT_STATUS_INACTIVE, translations)],
		];

		var currentClientWithUnchangedVatin = clientId && clientList?.clients && clientList.clients.filter(function (client) {
			return client.clientId === clientId;
		}).length > 0;
		const showWarningOnSubmit = lastVatin && !clientListPending && clientList?.clients && clientList.clients.length > 0 && !currentClientWithUnchangedVatin;

		const validationSchema = Yup.object().shape({
			name: Yup.string()
				.required(translations.warningFieldRequired),
			vatin: Yup.string()
				.required(translations.warningFieldRequired)
				.matches(/^\d{10}$/, translations.warningValueInvalid),
			mainAddressPostalCode: Yup.string()
				.matches(/^\d{2}-\d{3}$/, translations.warningValueInvalid),
			invoiceAddressPostalCode: Yup.string()
				.matches(/^\d{2}-\d{3}$/, translations.warningValueInvalid),
			dosimetryReportAddressPostalCode: Yup.string()
				.matches(/^\d{2}-\d{3}$/, translations.warningValueInvalid),
			contactPersonFirstName: Yup.string(),
			contactPersonLastName: Yup.string(),
			contactPersonEmail: Yup.string()
				.email(translations.warningValueInvalid),
			contactPersonPhone: Yup.string()
				.max(30, translations.warningValueTooLong),
		});

		const vatinInputMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
		const postalCodeInputMask = [/\d/, /\d/, '-', /\d/, /\d/, /\d/];
		const randomAutoComplete = Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
		return (
			<div>
				{ pageHeader}
				{ initialValues && <Formik
					enableReinitialize
					initialValues={initialValues}
					validationSchema={validationSchema}
					onSubmit={fields => { this.handleSubmit(fields) }}>
					{props => (
						<Form autoComplete={randomAutoComplete}>
							<div className="col-12 mb-4">
								<div className="card border-light shadow-sm components-section">
									<div className="card-body">
										<h2 className="h5 mb-4">{translations.basicData}</h2>
										<div className="row mb-4">
											<div className="col-lg-4 col-sm-6">
												<ValidatedField name="clientId" label={translations.number} readOnly={clientId ? "readOnly" : null} {...props} />
											</div>
											<div className="col-lg-4 col-sm-6">
												<ValidatedMaskedField name="vatin" label={translations.vatin} mask={vatinInputMask} onChange={this.onChangeVatin} {...props} />
											</div>
											<div className="col-lg-4 col-sm-6">
												<ValidatedSelectField name="status" label={translations.status} keyValueMap={clientStatusesToDropDownList} {...props} />
											</div>
										</div>
										<div className="row mb-4">
											<div className="col-lg-4 col-sm-6">
												<ValidatedField name="name" label={translations.name} {...props} />
											</div>
											<div className="col-lg-4 col-sm-6">
												<ValidatedField name="backgroundRadiation" label="Promieniowanie tła" {...props} />
											</div>
											<div className="col-lg-4 col-sm-6">
												<ValidatedDateField name="since" label="Klient od" {...props} />
											</div>
										</div>
										<div className="row mb-4">
											<div className="col-lg-4 col-sm-6">
												<div className="form-group mb-3">
													<label htmlFor="remarks">{translations.remarks}</label>
													<Field id="remarks" name="remarks" component="textarea" className="form-control" rows="4" />
												</div>
											</div>
										</div>
										<h2 className="h5 mb-4">Adres</h2>
										<div className="row mb-4">
											<div className="col-lg-4 col-sm-6">
												<ValidatedField name="mainAddressStreet" label={translations.street} {...props} />
											</div>
											<div className="col-lg-4 col-sm-6">
												<ValidatedMaskedField name="mainAddressPostalCode" label={translations.postalCode} mask={postalCodeInputMask} {...props} />
											</div>
											<div className="col-lg-4 col-sm-6">
												<ValidatedField name="mainAddressCity" label={translations.city} {...props} />
											</div>
										</div>
										<h2 className="h5 mb-4">Adres korespondencyjny</h2>
										<div className="row mb-4">
											<div className="col-lg-4 col-sm-6">
												<ValidatedField name="invoiceAddressStreet" label={translations.street} {...props} />
											</div>
											<div className="col-lg-4 col-sm-6">
												<ValidatedMaskedField name="invoiceAddressPostalCode" label={translations.postalCode} mask={postalCodeInputMask} {...props} />
											</div>
											<div className="col-lg-4 col-sm-6">
												<ValidatedField name="invoiceAddressCity" label={translations.city} {...props} />
											</div>
										</div>
										<h2 className="h5 mb-4" hidden>Adres do raportu dozymetrycznego</h2>
										<div className="row mb-4" hidden>
											<div className="col-lg-4 col-sm-6">
												<ValidatedField name="dosimetryReportAddressStreet" label={translations.street} {...props} />
											</div>
											<div className="col-lg-4 col-sm-6">
												<ValidatedMaskedField name="dosimetryReportAddressPostalCode" label={translations.postalCode} mask={postalCodeInputMask} {...props} />
											</div>
											<div className="col-lg-4 col-sm-6">
												<ValidatedField name="dosimetryReportAddressCity" label={translations.city} {...props} />
											</div>
										</div>
										<h2 className="h5 mb-4">{translations.contactPerson}</h2>
										<div className="row mb-4">
											<div className="col-lg-4 col-sm-6">
												<ValidatedField name="contactPersonFirstName" label={translations.firstName} {...props} />
											</div>
											<div className="col-lg-4 col-sm-6">
												<ValidatedField name="contactPersonLastName" label={translations.lastName} {...props} />
											</div>
										</div>
										<div className="row mb-4">
											<div className="col-lg-4 col-sm-6">
												<ValidatedField name="contactPersonEmail" label={translations.email} {...props} />
											</div>
											<div className="col-lg-4 col-sm-6">
												<ValidatedField name="contactPersonPhone" label={translations.phone} maxLength="30" {...props} />
											</div>
										</div>
										<div className="row mb-5 mb-lg-5">
											<div className="col-lg-3 col-md-6">
												{!showWarningOnSubmit &&
													<div className="form-group mb-3">
														<button id="saveButton" type="submit" className="btn btn-primary me-2" disabled={saveClientPending ? "disabled" : null} >{translations.actionSave}</button>
													</div> }
												{showWarningOnSubmit &&
													<div className="form-group mb-3">
														<button type="button" className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#confirm-save-modal" disabled={saveClientPending ? "disabled" : null} >{translations.actionSave}</button>
														<ConfirmActionModal id="confirm-save-modal" bodyText={`${translations.warningClientWithSpecifiedVatinAlreadyExists}. ${translations.confirmationSaveChanges}`} confirmText={translations.yes} cancelText={translations.no} onClick={props.handleSubmit} />
													</div>
												}
											</div>
										</div>
									</div>
								</div>
							</div>
						</Form>)}
				</Formik>}
			</div>
		)
	}
}

const mapStateToProps = state => ({
	clientPending: getClientPending(state),
	client: getClient(state),
	clientError: getClientError(state),
	newClient: getNewClient(state),
	newClientPending: getNewClientPending(state),
	newClientError: getNewClientError(state),
	addClientPending: addClientPending(state),
	addClientId: addClientId(state),
	saveClientPending: saveClientPending(state),
	clientListPending: getClientListPending(state),
	clientList: getClientList(state),
	clientListError: getClientListError(state),
	translations: getTranslations(state)
})

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ fetchClientAction, fetchNewClientAction, addClientAction, saveClientAction, fetchClientListAction }, dispatch)
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ClientEdit)